/**
 * Simple checkbox visual component that doesn't cause infinite loops
 * Used in place of Radix Checkbox when combined with parent onClick handlers
 */
import { Check } from "lucide-react";

export function CheckBox({ checked, className = "" }) {
  if (checked) {
    return (
      <div className={`w-4 h-4 rounded-sm bg-white flex items-center justify-center ${className}`}>
        <Check className="w-3 h-3 text-black" />
      </div>
    );
  }
  return <div className={`w-4 h-4 rounded-sm border-2 border-white/40 ${className}`} />;
}

export default CheckBox;
